import {Component, OnInit, ViewChild} from '@angular/core';
import {PageHeaderBarConfig, PageSubheaderBarConfig} from '../../../fw/pages/page-config-api';
import {BreadcrumService, BreadcrumStep } from '../../../fw/services/breadcrum.service';
import {AutoUnsubscribe} from '../../../fw/decoractors/AutoUnsubscribe';
import {FormBuilder, FormGroup} from "@angular/forms";
import {DynamicGridComponent} from "../../../fw/dynamic-grids/dynamic-grid.component";
import {ColumnDefinition} from "../../../fw/dynamic-grids/column-definition";
import {StockInventoryService} from "./stock-inventory.service";
import {SharedService} from "../../shared/shared.service";
import {DtoArticleInventory} from "./models/DtoArticleInventory";
import {SharedDataService} from "../../shared/shared-data.service";
import {DtoBranchUser} from "../../shared/models/DtoBranchUser";


@Component({
    selector: 'app-stock-inventory',
    template: require('./stock-inventory.component.html'),
    styles: [require('./stock-inventory.component.css')]
})

@AutoUnsubscribe()
export class StockInventoryComponent implements OnInit {
    @ViewChild('grid', {static: false}) grid: DynamicGridComponent;
    filterHeaderConfig: PageHeaderBarConfig;
    pshbConfig: PageSubheaderBarConfig;
    years: Array<{ text: string, value: number }> = [];
    filterForm: FormGroup;
    branches: DtoBranchUser[];
    data: DtoArticleInventory[];
    excelFilename: string;
    columnDefinition: ColumnDefinition[] = [
        {
            key: 'index',
            label: 'Nummer',
            type: 'number',
            width: '100px'
        },
        {
            key: 'description',
            label: 'Omschrijving',
            type: 'string',
            width: '350px'
        }
    ];

    constructor(private breadcrumService: BreadcrumService,
                private fb: FormBuilder,
                private ds: StockInventoryService,
                private ss: SharedService,
                private sds: SharedDataService) { }

    ngOnInit() {
        let steps: Array<BreadcrumStep> = [
            { text: 'hoofdmenu', isLastStep: false },
            { text: 'voorraad', isLastStep: false },
            { text: 'inventarisatie', isLastStep: true }];
        this.breadcrumService.setCurrentLocation(steps, true, 'home');
        this.filterHeaderConfig = {
            title: 'INSTELLINGEN',
            buttonDefinition: [
                {
                    description: 'BEKIJKEN',
                    isSmall: false,
                    clickEventType: 'search'
                }
            ]
        };

        this.pshbConfig = {
            title: 'INVENTARISATIE OVERZICHT',
            buttonDefinition: [
                {
                    description: 'EXCEL',
                    isSmall: false,
                    clickEventType: 'excel'
                }
            ]
        };

        for (let i = 0; i < 5; i++) {
            this.years.push({
                text: (this.ss.getCurrentYear() - i).toString(),
                value: this.ss.getCurrentYear() - i
            });
        }

        this.filterForm = this.fb.group({
            year: this.ss.getCurrentYear()
        });

        this.sds.getBranches().subscribe((res: DtoBranchUser[]) => {
            this.branches = res;
            for (let i = 0; i < this.branches.length; i++) {
                this.columnDefinition.push({
                    type: 'string',
                    key: `branches[${i}].inventoryDesc`,
                    label: this.branches[i].companyName,
                    width: `${this.ss.CalculateColumnWidth(this.branches[i].companyName)}px`
                });
            }
        });
    }

    ngAfterViewInit() {
        this.loadData();
    }

    loadData() {
        this.ds.getInventoryByYear(this.filterForm.get('year').value).subscribe((res: DtoArticleInventory[]) => {
            this.data = res;
            this.excelFilename = `inventarisatie - ${this.filterForm.get('year').value}.xlsx`;
            this.grid.showData(this.data);
            this.grid.fitColumns();
        });
    }

    phbBtnClicked(event) {
        if (event == 'search') {
            this.loadData();
        }
    }

    pshbBtnClicked(event) {
        if (event == 'excel') {
            this.grid.saveAsExcel();
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/stock/stock-inventory/stock-inventory.component.ts